















































































import { Account, Provider } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class UpsertProviderModal extends Vue {
  @Prop({ required: false }) provider: Provider

  private providerSave: Provider = {
    id: 0,
    name: '',
    responsibleId: '',
    createdOn: '',
    updatedOn: ''
  }

  private responsibleOptions: Account[] = []

  @Watch('provider', { deep: true })
  onProviderChanged() {
    this.updateProvider()
  }

  get newProvider(): boolean {
    return this.provider == null || !this.provider.id
  }

  private updateProvider() {
    if (this.provider && this.provider.id) {
      Vue.set(this.providerSave, 'id', this.provider.id)
      Vue.set(this.providerSave, 'name', this.provider.name)
      Vue.set(this.providerSave, 'responsibleId', this.provider.responsibleId)
      this.preloadResponsible(this.provider.responsibleId)
    } else {
      this.clearForm()
    }
  }

  private async preloadResponsible(accountId: string) {
    if (!accountId) return
    try {
      const result = await ApiClient.searchAccounts(accountId, 1, 0)
      if (result.items.length > 0) {
        this.responsibleOptions = [result.items[0]]
      }
    } catch (e) {
      console.error('Error preloading responsible', e)
    }
  }

  searchAccounts(search: string, loading: (value: boolean) => void) {
    if (!search || search.length < 2) {
      this.responsibleOptions = []
      return
    }
    loading(true)
    ApiClient.searchAccounts(search, 20, 0)
      .then(result => {
        this.responsibleOptions = result.items
      })
      .catch(error => {
        console.error('Error searching accounts:', error)
      })
      .finally(() => loading(false))
  }

  private formOk(): boolean {
    return !!this.providerSave.name && !!this.providerSave.responsibleId
  }

  hideModal() {
    this.$bvModal.hide('UpsertProviderModal')
  }

  private saveForm(): void {
    if (!this.formOk()) {
      alert('Form not valid!')
      return
    }
    const promise = this.newProvider
      ? ApiClient.createProvider(this.providerSave)
      : ApiClient.updateProvider(this.providerSave.id, this.providerSave)

    promise
      .then((providerSaved: Provider) => {
        this.$emit('providerSaved', providerSaved)
        this.hideModal()
        this.clearForm()
      })
      .catch((ex: Error) => alert(`Error: ${ex.message}`))
  }

  private clearForm() {
    Vue.set(this.providerSave, 'id', 0)
    Vue.set(this.providerSave, 'name', '')
    Vue.set(this.providerSave, 'responsibleId', '')
    this.responsibleOptions = []
  }
}
